import React from 'react';
import { observer } from 'mobx-react';
import './gisheader.scss';

export const GISHeaderComponent = (props) => {
  return (
    <div>
      <header>
        <section id="main-menu">
          <div className="display-flex justify-content-between">
          </div>
        </section>
      </header>
    </div>
  );
};

export const GISHeader = observer(GISHeaderComponent);
